
import { axiosInstance, baseUrl, handleErrors } from "./auth";

// Past Event Add
export const VENDOR_ADD_PAST_EVENT = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/vendor/pastEvent/add`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
// Past Event Edit
export const VENDOR_EDIT_PAST_EVENT = async (params) => {
    try {
        const response = await axiosInstance.put(`${baseUrl}/vendor/pastEvent/update`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
// Past Event Delete
export const VENDOR_DELETE_PAST_EVENT = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/vendor/pastEvent/delete`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
// Past Event List
export const VENDOR_PAST_EVENT_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/vendor/pastEvent/list`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
